/**
 * ProcessorsEnum
 */
export var ProcessorsEnum;
(function (ProcessorsEnum) {
    ProcessorsEnum["PSE"] = "Pse Processor";
    ProcessorsEnum["ACCENDO"] = "Accendo Processor";
    ProcessorsEnum["STP"] = "STP Processor";
    ProcessorsEnum["CONFRONTA"] = "Banco Bogota Transfer Processor";
    ProcessorsEnum["ETPAYPLUS"] = "ETPayPlus Processor";
    ProcessorsEnum["ETPAY"] = "ETPay Processor";
    ProcessorsEnum["SAFETY_PAY_TRANSFER"] = "SafetyPay Processor";
    ProcessorsEnum["SAFETY_PAY_TRANSFER_PROCESSOR"] = "SafetyPay Transfer Processor";
})(ProcessorsEnum || (ProcessorsEnum = {}));
